export default function isTransitionForPrintView(transition) {
  if (!transition?.intent) return false;

  const { intent } = transition;
  return (
    intent?.router?.state?.fullQueryParams?.['printView'] === 'true' ||
    intent?.url?.match?.('printView=true')
  );
}
